import { Typography } from '@mui/material';

const PageTitle = ({ children, ...props }) => (
  <Typography
    fontSize={{ xs: 18, md: 20, lg: 28 }}
    fontWeight="bold"
    lineHeight="normal"
    {...props}
  >
    {children}
  </Typography>
);

export default PageTitle;
